<template>
    <header>
        <v-app-bar app flat color="white">
            <v-app-bar-nav-icon
                @click.stop="
                    $vuetify.breakpoint.mdAndUp
                        ? (mini = !mini)
                        : (leftDrawer = !leftDrawer)
                "
            ></v-app-bar-nav-icon>

            <v-spacer></v-spacer>

            <b-lang-menu v-model="lang"></b-lang-menu>

            <v-menu offset-y bottom transition="slide-y-transition">
                <template v-slot:activator="{ on }">
                    <v-btn
                        class="text-capitalize secondary--text"
                        text
                        v-on="on"
                    >
                        <v-avatar size="32" class="mr-2">
                            <v-img :src="user.avatar"></v-img>
                        </v-avatar>
                        {{ user.full_name }}
                        <v-icon v-text="icons.mdiChevronDown"></v-icon>
                    </v-btn>
                </template>

                <v-list dense>
                    <v-list-item-group color="primary">
                        <v-list-item color="blue" @click="switchAccount()">
                            <v-list-item-icon class="mr-3">
                                <v-icon
                                    color="blue"
                                    v-text="icons.mdiAccountSwitch"
                                ></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title class="blue--text"
                                >Switch Account</v-list-item-title
                            >
                        </v-list-item>
                        <v-list-item color="red" @click="logout">
                            <v-list-item-icon class="mr-3">
                                <v-icon
                                    color="red"
                                    v-text="icons.mdiLogout"
                                ></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title class="red--text"
                                >Logout</v-list-item-title
                            >
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-menu>

            <!-- <v-btn text icon @click="goToSettingsPage()">
                <v-icon v-text="icons.mdiCogOutline"></v-icon>
            </v-btn> -->
        </v-app-bar>

        <v-navigation-drawer
            app
            color="secondary"
            v-model="leftDrawer"
            :mini-variant="mini"
            :mini-variant-width="80"
            :temporary="$vuetify.breakpoint.smAndDown"
            :permanent="$vuetify.breakpoint.mdAndUp"
            dark
        >
            <v-list-item href="https://www.roadcube.com"
                class="d-block pa-3 home-link"
                style=""
            >
                <v-img
                    src="../assets/home/logo.png"
                    class="mx-auto"
                    width="70%"
                    contain
                ></v-img>
            </v-list-item>

            <v-divider></v-divider>

            <v-row class="pt-4" no-gutters justify="center">
                <!-- <v-sheet light class="pa-2 rounded-circle">
                    <v-skeleton-loader
                        :loading="loading"
                        type="image"
                        width="50"
                        height="50"
                        class="rounded-circle"
                    >
                        <v-img
                            :src="logo"
                            width="50"
                            height="50"
                            contain
                            class="rounded-circle"
                        ></v-img>
                    </v-skeleton-loader>
                </v-sheet> -->

                <v-col cols="12" class="text-center white--text">
                    {{ supplierInfo.name }}
                </v-col>
            </v-row>

            <v-container
                class="pa-0"
                :style="{ height: containerHeight, overflow: 'auto' }"
            >
                <v-list
                    v-for="navLink in navLinks"
                    :key="navLink.title['en']"
                    dense
                    nav
                    :subheader="navLink.title['en'] !== 'MANAGE'"
                >
                    <v-subheader
                        class="text-caption"
                        :class="{ 'justify-center': mini }"
                        v-text="navLink.title[lang]"
                    ></v-subheader>

                    <div
                        v-for="item in navLink.children"
                        :key="item.title['en']"
                    >
                        <v-tooltip v-if="mini" color="secondary" right>
                            <template v-slot:activator="{ on }">
                                <v-list-item
                                    v-if="
                                        !item.hide &&
                                        item.title['en'] == 'Logout'
                                    "
                                    :exact="item.exact"
                                    @click="logout"
                                >
                                    <v-list-item-icon>
                                        <v-icon v-text="item.icon"></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title
                                        v-text="item.title[lang]"
                                    ></v-list-item-title>
                                </v-list-item>

                                <v-list-item
                                    v-else-if="!item.hide"
                                    :to="item.to"
                                    :exact="item.exact"
                                    v-on="on"
                                >
                                    <v-list-item-icon>
                                        <v-icon v-text="item.icon"></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title
                                        v-text="item.title[lang]"
                                    ></v-list-item-title>
                                </v-list-item>
                            </template>

                            <span
                                class="font-weight-bold"
                                v-text="item.title[lang]"
                            ></span>
                        </v-tooltip>

                        <v-list-item
                            v-else-if="
                                !item.hide && item.title['en'] == 'Logout'
                            "
                            @click="logout"
                            :exact="item.exact"
                        >
                            <v-list-item-icon>
                                <v-icon v-text="item.icon"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title
                                v-text="item.title[lang]"
                            ></v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-else-if="!item.hide"
                            :to="item.to"
                            :exact="item.exact"
                        >
                            <v-list-item-icon>
                                <v-icon v-text="item.icon"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title
                                v-text="item.title[lang]"
                            ></v-list-item-title>
                        </v-list-item>
                    </div>
                </v-list>
            </v-container>
        </v-navigation-drawer>

        <v-navigation-drawer v-model="rightDrawer" app right temporary>
            <v-toolbar flat>
                <v-toolbar-title>Settings</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.stop="rightDrawer = !rightDrawer">
                    <v-icon>{{ icons.mdiClose }}</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
        </v-navigation-drawer>
    </header>
</template>

<script>
// import supplierPanel from "@/store/modules/supplierPanel";

import {
    mdiChevronDown,
    mdiLogout,
    mdiCogOutline,
    mdiClose,
    mdiAccountSwitch,
} from "@mdi/js";

import navLinks from "@/utils/supplierPanel/navLinks";
import { mapActions, mapState, mapMutations } from "vuex";
import axios from "axios";
import API from "@/models/API";

export default {
    name: "LoyaltyHeader",

    mixins: [navLinks],

    data() {
        return {
            icons: {
                mdiChevronDown,
                mdiLogout,
                mdiCogOutline,
                mdiClose,
                mdiAccountSwitch,
            },
            mini: false,
            leftDrawer: false,
            rightDrawer: false,
            paymentErrorDialog: false,
        };
    },

    computed: {
        ...mapState(["user", "supplierInfo"]),

        lang: {
            get() {
                return this.$route.params.lang;
            },

            set(val) {
                if (val !== this.$route.params.lang)
                    this.$router.push(
                        `/${val}/` + this.$route.fullPath.slice(4)
                    );
            },
        },

        loading() {
            return this.$store.state.loyaltyPanel.loading;
        },

        logo() {
            return this.$store.state.loyaltyPanel.company.logo;
        },

        paymentError() {
            return this.$store.state.loyaltyPanel.paymentError;
        },

        companyName() {
            return this.$store.state.loyaltyPanel.company.name;
        },

        containerHeight() {
            return this.mini ? "calc(100vh - 223px)" : "calc(100vh - 213px)";
        },
    },

    mounted() {
        this.getSupplierInfo();
    },

    methods: {
        ...mapActions(["changeLanguage", "getSupplierInfo"]),
        ...mapMutations(["setAccessToken"]),

        async logout() {
            try {
                const { data } = await API.post(`/users/logout`);

                localStorage.removeItem("storeId");
                localStorage.removeItem("companyId");
                localStorage.removeItem("accessToken");
                this.setAccessToken("");
                window.location = "https://RoadCube.com";
            } catch (ex) {
                console.log(ex.response.data);
            }
        },

        goToSettingsPage() {
            this.$router.push(`/${this.lang}/supplierPanel/settings`);
        },

        switchAccount() {
            this.$router.push({ name: "UserStores" });
        },
    },

    watch: {
        lang(val) {
            let body = {
                language_id: val == "en" ? 1 : val == "el" ? 2 : 3,
            };

            this.changeLanguage(body);
        },

        paymentError(val) {
            if (val) {
                this.paymentErrorDialog = true;
            }
        },
    },
};
</script>

<style>
.v-skeleton-loader__heading {
    width: 100% !important;
}
</style>

<style scoped>
.home-link:hover {
    background-color: #1bbae1 !important;
}

::-webkit-scrollbar {
    width: 4px;
}

::-webkit-scrollbar-track {
    background: #2a3042;
}

::-webkit-scrollbar-thumb {
    background: grey;
}
</style>
